import { Fragment } from 'react';
import { Toolbar, ToolbarHeading, ToolbarPageTitle } from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { useLayout } from '@/providers';
import { ServiceRequestListings } from './components/ServiceRequestListings';

const ServiceRequestManagement = ({
  harborId,
}: {
  harborId?: string | null;
}) => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle text="Service Requests" />
          </ToolbarHeading>
        </Toolbar>
      )}

      <ServiceRequestListings harborId={harborId || null} />
    </Fragment>
  );
};

export { ServiceRequestManagement };
